var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-hashtag" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("tags")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-sm-1 flex justify-center items-center" },
          [
            _c("q-btn", {
              attrs: { label: _vm.$t("icon"), color: "tertiary" },
              on: {
                click: function($event) {
                  _vm.show_icons = true
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-11 col-xs-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 30 } },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    maxlength: "30"
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("select-multiple", {
              attrs: {
                label: "knowledge_areas",
                filters: _vm.areas,
                options: _vm.area_countries,
                error: _vm.$v.areas.$error,
                input: _vm.$v.areas.$touch
              },
              on: {
                on_value: function($event) {
                  _vm.areas = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "q-mt-md\trow col-xs-12 col-sm-6 justify-around" },
          [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-5 " },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("background_color")))
                ]),
                _c("q-color-picker", {
                  model: {
                    value: _vm.background_color,
                    callback: function($$v) {
                      _vm.background_color = $$v
                    },
                    expression: "background_color"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-5",
                class: _vm.$q.platform.is.desktop ? "q-mt-none" : "q-mt-md"
              },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("text_color")))
                ]),
                _c("q-color-picker", {
                  model: {
                    value: _vm.text_color,
                    callback: function($$v) {
                      _vm.text_color = $$v
                    },
                    expression: "text_color"
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              " column col-xs-12 col-sm-6 q-mt-md flex justify-center items-center"
          },
          [
            _c("p", { staticClass: "caption text-bold" }, [
              _vm._v(_vm._s(_vm.$t("preview")))
            ]),
            _c(
              "q-card",
              {
                staticClass:
                  "flex justify-center items-center card-size round-borders",
                style: "background-color:" + _vm.background_color
              },
              [
                _c(
                  "q-card-main",
                  { staticClass: "text-center title q-title text-white" },
                  [
                    _c("q-icon", {
                      staticClass: "q-mb-sm",
                      style: "color:" + _vm.text_color,
                      attrs: { name: _vm.icon }
                    }),
                    _c(
                      "p",
                      {
                        staticClass: "q-mb-none text-center text-weight-bold",
                        style: "color:" + _vm.text_color
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "row reverse col-12" }, [
          _c(
            "div",
            { class: _vm.$q.platform.is.desktop ? " " : "col-6" },
            [
              _c("p", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("status")))
              ]),
              _c("q-btn-toggle", {
                attrs: {
                  "toggle-color": _vm.getColorStatus,
                  options: _vm.statuses
                },
                model: {
                  value: _vm.status,
                  callback: function($$v) {
                    _vm.status = $$v
                  },
                  expression: "status"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              class: _vm.$q.platform.is.desktop ? "q-mr-md" : "q-mr-none col-6"
            },
            [
              _c("p", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("highlight")))
              ]),
              _c("q-btn-toggle", {
                attrs: {
                  "toggle-color": _vm.getColorFeatured,
                  options: _vm.featureds
                },
                model: {
                  value: _vm.is_featured,
                  callback: function($$v) {
                    _vm.is_featured = $$v
                  },
                  expression: "is_featured"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_tags" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": { maxWidth: _vm.getMaxWidth, minHeight: "80vh" }
          },
          model: {
            value: _vm.show_icons,
            callback: function($$v) {
              _vm.show_icons = $$v
            },
            expression: "show_icons"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_icons = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("icon")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-search", {
                    staticClass: "full-width",
                    attrs: { inverted: "", color: "none", debounce: 500 },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                _vm._l(_vm.iconList, function(icon, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "category-icon-item",
                      on: {
                        click: function($event) {
                          return _vm.selectIcon(icon)
                        }
                      }
                    },
                    [_c("q-icon", { attrs: { name: "fas fa-" + icon } })],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }